//
//
//
//
//
//

import Home from '~/components/PagsmileCard/HomeIndex.vue'

export default {
  components: {
    Home
  },
  layout: 'pagsmile-card',
  head () {
    return {
      title: 'Pagsmile | '.concat(this.$t('seo.slogan')),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
